/**
 * Representa el estado completo de un Servicio Divino en el flujo de creación/edición
 * Este es el single source of truth para todos los datos del servicio
 */
export interface DivineServiceState {
  // Identificación
  id: string | null;
  
  // Estados de carga
  isLoading: boolean;
  isSaving: boolean;
  isEditMode: boolean;
  isNewService: boolean;
  isClosed: boolean;
  
  // Datos básicos del servicio
  date: Date | null;
  type: number | null;
  bibleText: string;
  organizationUnitId: string;
  memberInCharge: string;
  location: string;
  notes: string;
  
  // Ofrendas
  offeringsARS: number;
  offeringsUSD: number;
  
  // Asistencia
  totalAdults: number;
  totalMinors: number;
  
  // Visitas
  visitsAdults: number;
  visitsMinors: number;
  
  // Almas nuevas
  newAdults: number;
  newMinors: number;
}

/**
 * Estado inicial por defecto para un nuevo Servicio Divino
 */
export const INITIAL_DIVINE_SERVICE_STATE: DivineServiceState = {
  id: null,
  isLoading: false,
  isSaving: false,
  isEditMode: false,
  isNewService: true,
  isClosed: false,
  date: null,
  type: null,
  bibleText: '',
  organizationUnitId: '',
  memberInCharge: '',
  location: '',
  notes: '',
  offeringsARS: 0,
  offeringsUSD: 0,
  totalAdults: 0,
  totalMinors: 0,
  visitsAdults: 0,
  visitsMinors: 0,
  newAdults: 0,
  newMinors: 0
};

/**
 * Estado de visibilidad de campos opcionales
 */
export interface OptionalFieldsVisibility {
  memberInCharge: boolean;
  location: boolean;
  notes: boolean;
  offerings: boolean;
  visits: boolean;
  newSouls: boolean;
}

/**
 * Visibilidad inicial (todos los campos opcionales ocultos)
 */
export const INITIAL_OPTIONAL_FIELDS_VISIBILITY: OptionalFieldsVisibility = {
  memberInCharge: false,
  location: false,
  notes: false,
  offerings: false,
  visits: false,
  newSouls: false
};
